import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo, useCallback, useEffect } from 'react';
import { Helmet } from 'react-helmet/es/Helmet';
import { useDispatch } from 'react-redux';
import { reset } from 'redux-form';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { toDotArray } from '../../../../helpers/common/ArrayHelper';
import { propShape } from '../../../../helpers/custom-prop-types';
import { formValidateScroll } from '../../../../helpers/form';
import { compose } from '../../../../helpers/recompose';
import Layout from '../../../Layout';
import Breadcrumb from '../../../Layout/Breadcrumb';
import AuthenticationHoc from '../../../System/AuthenticationHoc';
import RfpPageTitle from '../../../Ui/Rfp/RfpPageTitle';
import RfpHoc from '../Hoc/RfpHoc';
import { rfpQuestionUseCase } from '../UseCase/RfpQuestionUseCase';
import RfpQuestionHoc from './Hoc/RfpQuestionHoc';
import RfpQuestionSkeleton from './Parts/RfpQuestionSkeleton';
import RfpQuestionAddContent from './RfpQuestionAddContent';
const RfpQuestionAdd = (props) => {
    const { question, rfp } = props;
    const { id, name } = rfp;
    const { can_add_question_count: canAddQuestionCount, is_can_add_question: isCanAddQuestion, } = question;
    const title = '質問内容を入力';
    const pans = useMemo(() => [
        {
            link: '/mypage',
            text: 'マイページ',
        },
        {
            link: '/project/professional',
            text: '募集中のプロジェクト',
        },
        {
            link: `/project/professional/${id}`,
            text: name,
        },
        {
            link: `/project/professional/${id}/question`,
            text: '質問一覧',
        },
        {
            text: title,
        },
    ], [id, name, title]);
    const history = useNavigate();
    const dispatch = useDispatch();
    const nextPath = `/project/professional/${id}/question/confirm`;
    const formName = 'RfpQuestionAddForm';
    const onSubmit = useCallback(() => {
        history.push(nextPath);
    }, [history, nextPath]);
    const onSubmitFail = useCallback((errors) => {
        const dots = Object.keys(toDotArray(errors || {}, '', {}, true));
        formValidateScroll(dots[dots.length - 1]);
    }, []);
    useEffect(() => () => {
        if (window.location.pathname !== nextPath) {
            dispatch(reset(formName));
        }
    }, [dispatch, nextPath, formName]);
    if (!isCanAddQuestion || canAddQuestionCount === 0) {
        return _jsx(CustomRedirect, { to: `/project/professional/${id}/question` });
    }
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main rfp_question_container rfp_common_container' }, { children: [_jsx(Helmet, { children: _jsx("title", { children: `${title}｜PROFFIT` }) }), _jsx(Breadcrumb, { lists: pans }), _jsx(RfpPageTitle, { text: name }), _jsx("div", Object.assign({ className: 'rfp_container' }, { children: _jsx("div", Object.assign({ className: 'rfp_content' }, { children: _jsx("div", Object.assign({ className: 'rfp_content_main' }, { children: _jsxs("div", Object.assign({ className: 'rfp-card is-rfp' }, { children: [_jsx("div", Object.assign({ className: 'rfp-card-head align-center' }, { children: _jsx("span", { children: title }) })), _jsx("div", Object.assign({ className: 'rfp-card-body' }, { children: _jsx("div", Object.assign({ className: 'rfp-card-form' }, { children: _jsx(RfpQuestionAddContent, { formName: formName, onSubmit: onSubmit, onSubmitFail: onSubmitFail, question: question, rfp: rfp }) })) }))] })) })) })) }))] })));
};
RfpQuestionAdd.propTypes = {
    question: propShape().isRequired,
    rfp: propShape().isRequired,
};
const enhance = compose(AuthenticationHoc({
    isCanUseProffit: true,
    isPreProfessional: false,
}), RfpHoc(rfpQuestionUseCase.questionRedirect, RfpQuestionSkeleton), RfpQuestionHoc({}, RfpQuestionSkeleton));
export default enhance(RfpQuestionAdd);
